import React from "react";
import Modal from "../../../Components/Base/Modal";
export default function ModalCampPublish(props) {
  return (
    <Modal addClass="modalCamp" close={props.close}>
      <div className="modal__camp">
        <div className="modal__assetDetail-delete perm long">
          <h4>Leaving form to add funds?</h4>
          <p className="sm">
              Leaving form for add funds.
          </p>
          <div className="modal__assetDetail-delete-btns">
            <button className="button secondary" onClick={props.close}>
              Cancel
            </button>
            <button className="button primary" onClick={props.onSaveCamp}>
              Save Campaign
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}